"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "campagna": {
    "bc54885b": [{
      "hkey": "c1dc1c0e",
      "slug": "quadrivio-gualdo",
      "name": "Quadrivio-Gualdo",
      "primary": true,
      "skipSearch": false
    }],
    "galdo": [{
      "hkey": "c1dc1c0e",
      "slug": "quadrivio-gualdo",
      "name": "Quadrivio-Gualdo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "campagna"
    }],
    "e9f16000": [{
      "hkey": "1655f56a",
      "slug": "campagna",
      "name": "Campagna",
      "primary": true,
      "skipSearch": false
    }],
    "mattinelle": [{
      "hkey": "1655f56a",
      "slug": "campagna",
      "name": "Campagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9253fd51": [{
      "hkey": "c1dc1c0e",
      "slug": "quadrivio-gualdo",
      "name": "Quadrivio-Gualdo",
      "primary": true,
      "skipSearch": false
    }],
    "quadrivio-basso": [{
      "hkey": "c1dc1c0e",
      "slug": "quadrivio-gualdo",
      "name": "Quadrivio-Gualdo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c84eeaf9": [{
      "hkey": "246e6827",
      "slug": "romandola-vallegrini",
      "name": "Romandola-Vallegrini",
      "primary": true,
      "skipSearch": false
    }],
    "romandola-madonna-del-ponte": [{
      "hkey": "246e6827",
      "slug": "romandola-vallegrini",
      "name": "Romandola-Vallegrini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8c4b5bde": [{
      "hkey": "c76816ac",
      "slug": "santa-lucia-santa-maria-la-nova",
      "name": "Santa Lucia-Santa Maria la Nova",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-la-nova": [{
      "hkey": "c76816ac",
      "slug": "santa-lucia-santa-maria-la-nova",
      "name": "Santa Lucia-Santa Maria la Nova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d7cd32b4": [{
      "hkey": "fd851f0e",
      "slug": "oppidi-san-zaccaria-serradarce",
      "name": "Oppidi-San Zaccaria-Serradarce",
      "primary": true,
      "skipSearch": false
    }],
    "serradarce": [{
      "hkey": "fd851f0e",
      "slug": "oppidi-san-zaccaria-serradarce",
      "name": "Oppidi-San Zaccaria-Serradarce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;